import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-chained-backend';
import XHR from 'i18next-xhr-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

import { Language } from './index';

const order = ['navigator', 'querystring', 'localStorage'];

const initI18next = async (): Promise<void> => {
  await i18next
    .use(LanguageDetector)
    .use(initReactI18next)
    .use(Backend)
    .init({
      fallbackLng: Language.EN,
      whitelist: [Language.DE, Language.EN, Language.EN_US],
      debug: false,
      cleanCode: true,
      saveMissing: false,
      interpolation: {
        escapeValue: false
      },
      react: {
        useSuspense: false
      },
      backend: {
        backends: [XHR],
        allowMultiLoading: true,
        backendOptions: [
          {
            loadPath: '/translations/generated/{{ns}}.{{lng}}.json',
            addPath: '/translations/generated/{{ns}}.{{lng}}.json'
          }
        ]
      },
      detection: {
        order
      }
    });
};

export default initI18next;
